import React from 'react';
import { Modal } from '../../components/modals/antd-modals';
import { BasicFormWrapper } from '../styled';
import { Button } from '../../components/buttons/buttons';

const DeleteErrorLogModal = ({ visible, onCancel, handleDelete, errorLog }) => {
  return errorLog ? (
    <Modal
      visible={visible}
      type="primary"
      title="Delete Error Log?"
      onCancel={onCancel}
      footer={[
        <div key="delete-error-log" className="car-modal-footer">
          <Button size="default" type="danger" key="submit" onClick={() => handleDelete(errorLog._id)}>
            Delete Error Log
          </Button>
          <Button size="default" type="white" key="black" outlined="true" onClick={onCancel}>
            Cancel
          </Button>
        </div>,
      ]}
    >
      <div className="car-modal">
        <BasicFormWrapper>
          <p>Delete Error Log ?</p>
        </BasicFormWrapper>
      </div>
    </Modal>
  ) : (
    <></>
  );
};

export default DeleteErrorLogModal;
